export default __webpack_public_path__ + "static/media/rating.0ec6d095.svg";